import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { uiStore } from 'shared/store/uiStore'
import { IntegrationKey } from 'entities/Integrations'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ConversationRoutes } from 'pages/conversations'
import { SettingsRoutes } from 'pages/settings'
import { IntegrationsRoutes } from 'pages/settings/pages/integrations/route/type'
import { RegisterPath } from 'pages/register/route/registerPath'

export const AuthLayout = observer(() => {
  const { authStore } = useEntitiesContext()

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)
    const utmSource = searchParams.get('utm_source')
    const isHubSpotAuth = utmSource === IntegrationKey.hubspot

    if (authStore.isLoggedIn) {
      if (authStore.closeAfterLogin) {
        setTimeout(() => {
          window.close()
        }, 100)
      } else {
        window.stop()
        window.location.href = isHubSpotAuth
          ? `/${SettingsRoutes.root}/${IntegrationsRoutes.root}/${IntegrationKey.hubspot}/${IntegrationsRoutes.description}`
          : authStore.authRedirectUrl || `/${ConversationRoutes.root}?${searchParams}`
      }
    } else if (authStore.hasOid === false) {
      if (window.location.pathname === `/${RegisterPath.root}`) return

      uiStore.changeRoute({
        path: `/${RegisterPath.root}?${searchParams}`,
      })
    }
  }, [authStore.isLoggedIn, authStore.hasOid])

  return <Outlet />
})
